import { useEffect, useState } from 'react';
import { executeNoBodyRequest } from 'src/common/hooks/widgets/fetchData';
import {
  environment,
  useEnv,
  getEnv,
  getVariable,
} from 'src/common/hooks/widgets/useEnv';

export interface emailProperties {
  emailFrom?: string;
  emailTo: string;
  emailCC?: string;
  emailSubject?: string;
  emailText: string;
  html?: string;
  attachments?: [
    {
      filename: string;
      path: string;
    },
  ];
}

// Note: variablesProperties must match the COS object structure stored in the remote service for this to
// work properly.
export interface variablesProperties {
  variables: {
    emailTo: string;
    emailSubject: string;
    hostingService: string;
  };
}

/**
 *
 */
export const useReadCOS = (
  feedback: string,
  setResponse: React.Dispatch<
    React.SetStateAction<{
      variables: {
        emailTo: string;
        emailSubject: string;
        hostingService: string;
      };
    }>
  >,
  emailJson: string,
) => {
  const [env] = useEnv();
  let server = '';
  switch (env) {
    case environment.production:
      server = 'https://emailer.5bcb70fa.public.multi-containers.ibm.com';
      break;
    case environment.preview:
      server =
        'https://emailer-test-development.53061809.public.multi-containers.ibm.com';
      break;
    case environment.stage:
      server =
        'https://emailer-test-development.53061809.public.multi-containers.ibm.com';
      break;
  }
  const headers: any = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  };
  useEffect(() => {
    console.log(`env ${env} and ${server}`);
    if (feedback) {
      executeNoBodyRequest(
        `${server}/store/target/${env}/${emailJson}`,
        'GET',
        headers,
      ).then((emailResponse) => {
        if (emailResponse.status === 200) {
          const content = JSON.stringify(emailResponse.message);
          const variables: variablesProperties = JSON.parse(content);
          setResponse(variables);
        } else {
          const result: variablesProperties = {
            variables: {
              emailTo: '',
              emailSubject: '',
              hostingService: '',
            },
          };
          setResponse(result);
        }
      });
    }
  }, [feedback, env]);
};

/**
 *
 */

export const readBucket = async (
  emailJson: string,
): Promise<[Record<string, string>[]]> => {
  const env = getVariable();
  let server = '';
  switch (env) {
    case environment.production:
      server = 'https://emailer.5bcb70fa.public.multi-containers.ibm.com';
      break;
    case environment.preview:
      server =
        'https://emailer-preprod.53061809.public.multi-containers.ibm.com';
      break;
    case environment.stage:
      server =
        'https://emailer-test-development.53061809.public.multi-containers.ibm.com';
      break;
  }
  console.log(`env ${env} and ${server} and ${emailJson}`);
  let response = [{}];

  if (emailJson.length !== 0) {
    const headers: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    await executeNoBodyRequest(
      `${server}/store/bucket/${env}/${emailJson}`,
      'GET',
      headers,
    ).then((bucketResponse) => {
      if (bucketResponse.status === 200) {
        const content = JSON.stringify(bucketResponse.message);
        const variables = JSON.parse(content);
        response = variables;
        console.log('Respuesta:', response);
      } else {
        response = [
          {
            message: `${JSON.stringify(env)}/${emailJson} not found`,
          },
        ];
      }
    });
  } else {
    response = [
      {
        message: `${JSON.stringify(env)} JSON file not provided.`,
      },
    ];
  }

  return [response];
};
